"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _getDate = require("date-fns/getDate");
var _getMonth = require("date-fns/getMonth");
var _getYear = require("date-fns/getYear");
var _isValid = require("date-fns/isValid");
var _endOfMonth = require("date-fns/endOfMonth");
var _Button2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _ModalHeader = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _ChevronBackward2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronBackward"));
var _IataPicker = _interopRequireDefault(require("../../IataPicker"));
var _Select = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Select"));
var _InputGroup = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputGroup"));
var _months = _interopRequireDefault(require("../../../../../consts/months"));
var _jsxRuntime = require("react/jsx-runtime");
var _ChevronBackward, _FormattedMessage, _Button;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const GetSingleBooking = _ref => {
  let {
    bookingId,
    bookingIdError,
    email,
    emailError,
    departureDate,
    departureDateError,
    IATA,
    IATAError,
    error,
    onBookingIdChange,
    onEmailChange,
    onDepartureDateChange,
    onIATAChange,
    onBack,
    onSubmit
  } = _ref;
  const intl = (0, _reactIntl.useIntl)();
  const [date, setDate] = React.useState(departureDate ? String((0, _getDate.getDate)(departureDate)) : "");
  const [month, setMonth] = React.useState(departureDate ? String((0, _getMonth.getMonth)(departureDate)) : "");
  const [year, setYear] = React.useState(departureDate ? String((0, _getYear.getYear)(departureDate)) : "");
  const getDateObject = React.useCallback(() => {
    if (date && month && year) {
      const d = Number(date);
      const m = Number(month);
      const y = Number(year);

      // only meaningful full year is allowed to not interpret 12 as 1912
      if (y < 1900) {
        return null;
      }
      const dateObject = new Date(y, m, d);

      // date has to be valid day of month
      if (dateObject > (0, _endOfMonth.endOfMonth)(new Date(y, m))) {
        return null;
      }
      return dateObject;
    }
    return null;
  }, [date, month, year]);
  const updateDate = React.useCallback(() => {
    const date = getDateObject();
    onDepartureDateChange((0, _isValid.isValid)(date) ? date : null);
  }, [getDateObject, onDepartureDateChange]);
  const handleChange = React.useCallback(ev => {
    const target = ev.target;
    const {
      value,
      name: fieldName
    } = target;
    if (fieldName === "date") {
      setDate(value);
    } else if (fieldName === "month") {
      setMonth(value);
    } else {
      setYear(value);
    }
  }, []);
  React.useEffect(() => {
    updateDate();
  }, [date, month, year, updateDate]);
  const inputGropuErrorMessage = departureDateError == null ? "" : intl.formatMessage(departureDateError);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader.default, {
      title: intl.formatMessage({
        id: "account.sign_in.single_booking.title"
      }),
      description: intl.formatMessage({
        id: "account.sign_in.single_booking.description"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
      dataTest: "MagicLogin-GetSingleBooking",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
        onSubmit: onSubmit,
        name: "loginGetSingleBooking",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
          direction: "column",
          spacing: "800",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
            direction: "column",
            children: [error != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
              type: "critical",
              icon: true,
              labelClose: intl.formatMessage({
                id: "orbit.button_close"
              }),
              children: error
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
              type: "number",
              inputMode: "decimal",
              label: intl.formatMessage({
                id: "account.sign_in.bid_number_label"
              }),
              placeholder: intl.formatMessage({
                id: "account.sign_in.bid_number_placeholder"
              }),
              value: bookingId,
              error: bookingIdError == null ? "" : intl.formatMessage(bookingIdError),
              onChange: onBookingIdChange,
              dataTest: "MagicLogin-BookingId"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
              inputMode: "email",
              autoComplete: "email",
              label: intl.formatMessage({
                id: "account.sign_in.incorrect_email_label"
              }),
              placeholder: intl.formatMessage({
                id: "account.sign_in.incorrect_email_placeholder"
              }),
              value: email,
              error: emailError == null ? "" : intl.formatMessage(emailError),
              onChange: onEmailChange,
              dataTest: "MagicLogin-Email"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputGroup.default, {
              error: inputGropuErrorMessage,
              label: intl.formatMessage({
                id: "account.sign_in.departure_date_label"
              }),
              flex: ["0 0 60px", "1 1 100%", "0 0 90px"],
              onChange: handleChange,
              dataTest: "MagicLogin-DateInput",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
                name: "date",
                placeholder: intl.formatMessage({
                  id: "account.date_input.date_placeholder"
                }),
                type: "number",
                inputMode: "decimal",
                value: date,
                dataTest: "MagicLogin-DateInput-Date"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
                name: "month",
                options: _months.default.map((monthLabel, i) => ({
                  value: i,
                  label: intl.formatMessage(monthLabel)
                })),
                placeholder: intl.formatMessage({
                  id: "account.date_input.select_month_placeholder"
                }),
                value: month,
                dataTest: "MagicLogin-DateInput-Month",
                label: intl.formatMessage({
                  id: "account.date_input.select_month_placeholder"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
                name: "year",
                placeholder: intl.formatMessage({
                  id: "account.date_input.year_placeholder"
                }),
                type: "number",
                inputMode: "decimal",
                value: year,
                dataTest: "MagicLogin-DateInput-Year"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
              width: "100%",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IataPicker.default, {
                id: "MagicLogin-IATA",
                value: IATA,
                onSelect: onIATAChange,
                error: IATAError && intl.formatMessage(IATAError)
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
            direction: "row",
            justify: "between",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button2.default, {
              type: "secondary",
              iconLeft: _ChevronBackward || (_ChevronBackward = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronBackward2.default, {
                ariaHidden: true
              })),
              onClick: onBack,
              dataTest: "MagicLogin-GetSingleBookingBack",
              children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "account.back"
              }))
            }), _Button || (_Button = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button2.default, {
              submit: true,
              dataTest: "MagicLogin-GetSingleBookingSubmit",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "submit"
              })
            }))]
          })]
        })
      })
    })]
  });
};
var _default = exports.default = GetSingleBooking;